import { ReactNode } from "react";
import styled from "styled-components";

export const Container = styled.div<{ children?: ReactNode }>`
  position: relative;
  flex: 1;
  max-width: 50%;
`;

export const AlertContainer = styled.div`
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  padding: ${({ theme }) => theme.space["space-3"]};
`;

export const StyledLink = styled.a`
  align-self: center;
  color: ${({ theme }) =>
    theme.colorTokens.component.notification.info.content};
  text-decoration: solid underline
    ${({ theme }) => theme.colorTokens.component.notification.info.content};
  text-decoration-skip-ink: none;
`;
